import React, { useEffect, useState } from "react";
import { renderTextField } from "../formcomponents";
import { reduxForm, Field, FieldArray } from "redux-form";
import FileListUpload from "./FileListUpload";
import { Grid, Divider, Label, Button } from "semantic-ui-react";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import FileArrList from "./FieldArray/FileArrList";
import EmployeeArrList from "./FieldArray/EmployeeArrList";
import PartnerArrList from "./FieldArray/PartnerArrList";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
const validate = (values) => {
  const errors = {};
  if (!values.companyName) {
    errors.companyName = "Required";
  }
  if (!values.activities) {
    errors.activities = "Required";
  }
  if (!values.typeOfCompany) {
    errors.typeOfCompany = "Required";
  }

  const employeeArrList = [];
  // if (values.employeeList.length || values.employeeList) {
  //   values.employeeList.forEach((item, index) => {
  //     const itemErr = {};
  //     if (!item || !item.employeeName) {
  //       itemErr.employeeName = "Required";
  //       employeeArrList[index] = itemErr;
  //     }
  //   });
  //   if (employeeArrList.length) {
  //     errors.employeeList = employeeArrList;
  //   }
  // }

  return errors;
};

const NewCompanyForm = (props) => {
  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    companyDetailList,
    indexVal,
  } = props;

  const [companyData, setcompanyData] = useState({});
  useEffect(() => {
    // console.log("companyDetailList", companyDetailList);
    // console.log("indexVal", indexVal);
    // initializeData(companyDetailList);
    getCompanyDetails(companyDetailList);
  }, [companyDetailList, indexVal]);
  const userDetail = userData();
  const [fileArrayList, setfileArrayList] = useState([]);
  const getCompanyDetails = async (data) => {
    await axios
      .post(BaseUrl + "getCompanyDetails", { companyId: data.companyId })
      .then((res) => {
        console.log("Company Detail", res.data);
        setcompanyData(res.data);
        initializeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [fileArrImageList, setfileArrImageList] = useState([]);

  const initializeData = (data) => {
    props.initialize({
      activities: data.activities,
      companyId: data.companyId,
      companyName: data.companyName,
      status: data.status,
      typeOfCompany: data.typeOfCompany,
      filesList: data.filesList,
      employeeList: data.employeeList,
      partnerList: data.partnerList,
    });

    if (data.filesList != "") {
      setfileArrImageList(data.filesList);
    }
    const values = [...fileArrayList];
    if (data.employeeList != "") {
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId });
      }
    }
    if (data.partnerList != "") {
      for (let i = 0; i < data.partnerList.length; i++) {
        values.push({ fileStorageId: data.partnerList[i].partnerFileId });
      }
    }
    setfileArrayList(values);
    getImageList(values, data.employeeList, data.partnerList);
  };
  const [imageList, setimageList] = useState([]);

  const getImageList = async (imgList, emp, partner) => {
    //  console.log("imgList", imgList);
    await axios
      .post(BaseUrl + "getFileDetailList", imgList)
      .then((res) => {
        // console.log("sdjsinscisnicussi", res.data);
        setimageList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sumbitForm = (values) => {
    console.log("submitObject", `${JSON.stringify(values, null, 2)}`);
    axios
      .post(BaseUrl + "createCompany", values)
      .then((res) => {
        // console.log(res.data);
        if (res.data.errCode == 200) {
          Swal.fire("Company Details Updated");
        }
      })
      .catch((error) => {});
  };
  return (
    <div>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <Field
              name="companyName"
              label="Name"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="activities"
              label="Activities"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="typeOfCompany"
              label="Type Of Company"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>{" "}
      <Divider section />
      <Label>
        <h3>Company Document List</h3>
      </Label>
      <FieldArray
        name="filesList"
        component={FileArrList}
        imageList={fileArrImageList}
      />
      <Divider section />
      <Label>
        <h3>Partner Document List</h3>
      </Label>
      <FieldArray
        name="partnerList"
        component={PartnerArrList}
        imageList={imageList}
      />
      <Divider section />
      <Label>
        <h3>Employee Document List</h3>
      </Label>
      <FieldArray
        name="employeeList"
        component={EmployeeArrList}
        imageList={imageList}
      />
      <br />
      <br />
      {userDetail.userRole == 1 && (
        <>
          {" "}
          <Button
            type="submit"
            floated="right"
            positive
            disabled={submitting}
            onClick={handleSubmit((values) =>
              sumbitForm({
                ...values,
              })
            )}
          >
            Save
          </Button>
          <Button
            floated="right"
            negative
            disabled={pristine || submitting}
            onClick={reset}
          >
            Cancel
          </Button>
        </>
      )}
      <br />
      <br />
    </div>
  );
};

export default reduxForm({
  form: "NewCompanyForm",
  validate,
})(NewCompanyForm);
